<template>
  <li class="nuttrema-list-item group" v-if="group.length > 0">
    <table>
      <colgroup>
        <col class="col-w-5">
        <col class="col-w-30">
        <col class="col-w-30">
        <col class="col-w-15">
      </colgroup>
      <thead>
        <tr class="group">
          <th colspan="3">{{ title }}</th>
        </tr>
        <tr class="item">
          <th class="cell-w-5"></th>
          <th class="cell-w-80">{{ $t('label.exchange_name') }}</th>
          <th class="cell-w-15"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="with-border-bottom" v-for="item in group">
          <td>
            <nuttrema-iconica-kcal
              :text="item.Exchange.name"
              :image="getImagePath(item)"
              :energyKcal="item.energy_kcal">
            </nuttrema-iconica-kcal>
          </td>
          <td class="col-w-30">
            <div class="content-title">
              <h4>{{ item.Exchange.name }}</h4>
            </div>
            <div class="content-text">
              <p>{{ item.exchange_amount | number-format(2) }} {{ item.ExchangeServingSize.title }} ({{ item.exchange_weight_gr | number-format(2) }}g) &#8776; {{ item.entity_amount | number-format(2) }} {{ item.EntityServingSize.title }} ({{ item.entity_weight_gr | number-format(2) }}g) {{ $t('label.of') }} <span>{{ item.Entity.name }}</span></p>
            </div>
          </td>
          <td class="col-w-15">
            <router-link
               v-if="edit"
               class="el-button el-button--text"
              :to="{ name: meta.navigation.edit, params: { exchangeID: item.exchange_id }, query: { entityExchangeID: item.id }}">
              {{ $t('label.edit') }} <i class="el-icon-arrow-right" aria-hidden="true"></i>
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </li>
</template>

<script>
import { isEmpty } from 'lodash';

import NuttremaIndexListItem from 'components/ui/list/nuttrema-index-list-item';
import NuttremaIconicaKcal from 'components/ui/label/nuttrema-iconica-kcal';

export default {
  name: 'cmpt-exchanges-list-item',
  mixins: [NuttremaIndexListItem],
  components: {
    NuttremaIconicaKcal,
  },
  methods: {
    getImagePath(item) {
      return !isEmpty(item.ExchangeImage) ? `${process.env.IMAGES_ROOT}${item.ExchangeImage.path}${item.ExchangeImage.thumbnails.medium.filename}` : null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/exchanges/cmpt-exchanges-list-item.vue